import { Grid, Paper } from "@material-ui/core";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { getBuildingSettingOption } from "../../../../api/buildingSettingApi";
import { useStylesSetting } from "../helpers/settingEvtOption";
import AssignBuildFloor from "./components/AssignBuildFloor";
import AssignBuilding from "./components/AssignBuilding";
import AssignBuildRoom from "./components/AssignBuildRoom";

export default function AssignBuildSetting() {
    const useClass = useStylesSetting();

    // ref
    const controllerRef = useRef(null);

    // component state
    const [isTabs, setIsTabs] = useState("AssignBuildRoom");
    const [option, setOption] = useState({ building: [], floor: [] });

    // change tab
    const handleChangeTabs = useCallback(tab => {
        setIsTabs(tab);
    }, []);

    // fetch building setting option
    const fetchBuildingSettingOption = useCallback(async signal => {
        try {
            const buildingSettingOption = await getBuildingSettingOption(signal);
            if (buildingSettingOption) {
                setOption(currentState => ({
                    ...currentState,
                    building: buildingSettingOption?.buildingOption,
                    floor: buildingSettingOption?.floorOption,
                }));
            }
        } catch (error) {
            console.dir(error);
        }
    }, []);

    useEffect(() => {
        controllerRef.current = new AbortController();
        const init = async () => {
            await fetchBuildingSettingOption(controllerRef.current?.signal);
        };
        init();
        // to avoid memory leaked.
        return () => {
            controllerRef.current.abort();
        };
    }, [fetchBuildingSettingOption, isTabs]);

    return (
        <Grid container spacing={0}>
            <Grid item xs={12} className="mb-3">
                <h1 className="t-text-primary">Assign Building</h1>
            </Grid>
            {/* Tabs */}
            <Grid item xs={12}>
                <Grid container spacing={1} className="justify-content-lg-start">
                    <Grid item xs={12}>
                        <div className="row">
                            <div className="col-12">
                                <div
                                    className="d-flex align-items-center"
                                    style={{ overflowX: "auto", overflowY: "hidden" }}>
                                    <div className="col-4 col-sm-3 col-lg-2 px-0">
                                        <div
                                            className={`${useClass.boxlistRoom} ${
                                                isTabs === "AssignBuildRoom" ? "active" : ""
                                            }`}
                                            onClick={() => handleChangeTabs("AssignBuildRoom")}>
                                            <p className="text-typo">{`Room`}</p>
                                        </div>
                                    </div>
                                    <div className="col-4 col-sm-3 col-lg-2 px-0">
                                        <div
                                            className={`${useClass.boxlistRoom} ${
                                                isTabs === "AssignBuildFloor" ? "active" : ""
                                            }`}
                                            onClick={() => handleChangeTabs("AssignBuildFloor")}>
                                            <p className="text-typo">{`Floor`}</p>
                                        </div>
                                    </div>
                                    <div className="col-4 col-sm-3 col-lg-2 px-0">
                                        <div
                                            className={`${useClass.boxlistRoom} ${
                                                isTabs === "AssignBuilding" ? "active" : ""
                                            }`}
                                            onClick={() => handleChangeTabs("AssignBuilding")}>
                                            <p className="text-typo">{`Building`}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Grid>
            {/* content */}
            <Grid item xs={12}>
                <Paper>
                    {isTabs === "AssignBuildRoom" && (
                        <AssignBuildRoom buildingOption={option?.building} floorOption={option?.floor} />
                    )}
                    {isTabs === "AssignBuildFloor" && <AssignBuildFloor buildingOption={option?.building} />}
                    {isTabs === "AssignBuilding" && <AssignBuilding />}
                </Paper>
            </Grid>
        </Grid>
    );
}
